import React from 'react'

import Base from '../_Base'

const UniversalAll = (props) => (
  <Base width="38" height="22" viewBox="0 0 38 22" fill="none" {...props}>
    <path
      d="M3.701 1.642A2 2 0 0 1 5.67 0h29.935a2 2 0 0 1 1.967 2.358l-3.272 18A2 2 0 0 1 32.33 22H2.396A2 2 0 0 1 .43 19.642l3.272-18Z"
      fill="#4A4E58"
      fillOpacity=".7"
    />
    <path
      d="M7.68 17H5.712l5.274-10.182h2.277L15.164 17h-1.97l-1.366-8.094h-.08L7.68 17Zm.726-3.992h5.37l-.249 1.481h-5.37l.25-1.481ZM16.504 17l1.69-10.182h1.845l-1.432 8.636h4.484L22.833 17h-6.33ZM24.433 17l1.69-10.182h1.845l-1.432 8.636h4.485L30.762 17h-6.329Z"
      fill="#BBB"
    />
  </Base>
)

export default UniversalAll
